export const UserRols = Object.freeze({
	DEFAULT_USER: "default_user",
	ORG_ADMIN: "org_admin",
	ARO_ADMIN: "aro_admin",
	ACCOUNTANT: "accountant",
	BILLING: "billing",
	INVOICES: "invoices",
	TREASURY: "treasury",
	CLIENT: "client",
});
